import React from 'react';
import uniq from 'lodash/uniq';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import * as ReactionsActions from 'Shared/actions/Reactions.actions';

// Selectors
import { getReactionsByReactionIdAndReactionType } from 'Shared/selectors/Reactions.selectors';
import { getUsersByUserIds } from 'Shared/selectors/Users.selectors';

// Components
import { WpReactions } from 'Wpds/components/reactions';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

const DefaultEmojis = {
  feedback: [
    'raised_hands',
    '100',
    'clap',
    'star-struck',
    'heart',
    'hugging_face',
    'heavy_plus_sign',
    '+1',
    'tada',
    'rocket',
  ],
};

type Props = {
  reactionableType: 'feedback';
  reactionableId: string;
};

const Reactions = ({ reactionableType, reactionableId }: Props) => {
  const dispatch = useDispatch();

  const isFeedback = reactionableType === 'feedback';
  const { id: currentUserId } = useCurrentUser();

  const reactions = useSelector(state =>
    getReactionsByReactionIdAndReactionType(state, {
      reactionableId,
      reactionableType,
    })
  );

  const userIds = uniq(
    reactions
      .valueSeq()
      .toJS()
      .map(r => r.userId)
  );
  const users = useSelector(state => getUsersByUserIds(state, { userIds }));

  const handleAddReaction = emoji => {
    dispatch(
      ReactionsActions.createReaction({
        reaction: emoji,
        reactionable_type: reactionableType,
        reactionable_id: reactionableId,
      })
    );
  };

  const handleRemoveReaction = ({ slug }) => {
    if (slug.startsWith('temp_')) return;
    dispatch(ReactionsActions.deleteReaction({ reactionSlug: slug }));
  };

  return (
    <WpReactions
      quickEmojis={isFeedback && DefaultEmojis.feedback}
      reactions={reactions.valueSeq().toJS()}
      currentUserId={currentUserId}
      onAddReaction={handleAddReaction}
      onRemoveReaction={handleRemoveReaction}
      users={users.valueSeq().toJS()}
    />
  );
};

export default Reactions;
